var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-slide-progress-bar",attrs:{"id":"bottom-progress-bar"}},[_c('div',{staticClass:"slide-progress-bar",style:({
      width: _vm.percentProgress
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }